// hooks/apiHooks/useFetchContents.ts
import { useEffect } from "react";
import { useCustomQuery } from "hooks/useQuery";
import { fetchContents } from "services/landingService";
import type { ContentResponse } from "types/content";
import type { QueryKey } from "@tanstack/react-query";

export const useFetchContents = (withContent: string, langId: string) => {
	const queryKey = [
		"contents",
		withContent,
		langId,
	] as const satisfies QueryKey;

	const query = useCustomQuery<ContentResponse>({
		queryKey,
		queryFn: () =>
			fetchContents({
				LangID: langId,
				WithContent: withContent,
			}),
		options: {
			staleTime: 1000 * 60 * 5,
			gcTime: 1000 * 60 * 30,
			refetchOnWindowFocus: false,
			retry: 1,
		},
	});

	useEffect(() => {
		if (query.error) {
			console.error("❌ Failed to fetch landing contents:", query.error);
		}
	}, [query.error]);

	return query;
};
